<script>

export default {
  name: 'Item',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleGoto() {
      if(this.item?.menuUrl) {
        console.log('item');
        window.history.pushState({}, '', this.item.menuUrl);
        // this.$router.push(this.item.menuUrl)
      } else {
        console.log('item');
        // TODO
      }
    }
  },
  render() {
    return h('div', {
      onClick: this.handleGoto
    }, this.item.name)
  }
}
</script>
